import { Component, OnInit, Renderer2, Input, ElementRef, ViewChild, HostListener, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-light-gallery-video',
  templateUrl: './light-gallery-video.component.html'
})
export class LightGalleryVideoComponent implements OnInit, AfterViewInit {
  @Input() videoUrl = '';
  @Input() currentTime = 0;
  @ViewChild('videoplayer') videoplayer!: ElementRef<HTMLVideoElement>;
  @Output() closeEvent = new EventEmitter<number>();

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.renderer.addClass(document.body, 'overflow-hidden');
    this.videoplayer.nativeElement.controls = true;
    this.videoplayer.nativeElement.currentTime = this.currentTime;
    this.videoplayer.nativeElement.play();
  }


  closePreview() {
    this.videoplayer.nativeElement.pause();
    this.videoUrl = '';
    this.renderer.removeClass(document.body, 'overflow-hidden');
    this.closeEvent.emit(this.videoplayer.nativeElement.currentTime);
  }

  @HostListener('window:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.videoUrl) {
      this.closePreview();
    }
  }

}
